const $ = require('jquery');

export default {
  init() {
    const hashas = window.location.hash.substr(1);

    $('.js-tab-toggler').on('click', (e: any) => {
      const target = $(e.currentTarget).data('target-id');
      $('.js-tab-toggler').removeClass('is-active');
      $(e.currentTarget).addClass('is-active');
      window.location.hash = target;
      e.preventDefault();
      $('.js-tab-article').hide();
      $(`[data-id="${target}"]`).show();
    });

    if (hashas) {
      $('.js-tab-toggler').removeClass('is-active');
      $(`[data-target-id="${hashas}"]`).addClass('is-active');
      $('.js-tab-article').hide();
      $(`[data-id="${hashas}"]`).show();
    }
  }
};
